
import { supabase } from '@/integrations/supabase/client';
import { STORAGE_KEYS } from '../constants/storage-keys';
import { saveData } from './entry-save-service';
import { toast } from 'sonner';

export const saveActiveFasting = (data: { startTime: string }): void => {
  try {
    if (import.meta.env.DEV) console.log('Saving active fasting:', data);
    saveData(STORAGE_KEYS.ACTIVE_FASTING, data);
  } catch (error) {
    console.error('Error in saveActiveFasting:', error);
    // Fallback to local storage if saveData fails
    localStorage.setItem(STORAGE_KEYS.ACTIVE_FASTING, JSON.stringify(data));
    toast.error('Error saving fasting data to the cloud. Working in offline mode.');
  }
};

export const getActiveFasting = (): { startTime: string } | null => {
  try {
    if (import.meta.env.DEV) console.log('Getting active fasting from localStorage');
    const data = localStorage.getItem(STORAGE_KEYS.ACTIVE_FASTING);
    const parsedData = data ? JSON.parse(data) : null;
    if (import.meta.env.DEV) console.log('Active fasting data:', parsedData);
    return parsedData;
  } catch (error) {
    console.error('Error in getActiveFasting:', error);
    return null;
  }
};

export const deleteActiveFasting = async (userId: string): Promise<void> => {
  try {
    if (import.meta.env.DEV) console.log('Clearing active fasting');
    localStorage.removeItem(STORAGE_KEYS.ACTIVE_FASTING);
    
    if (import.meta.env.DEV) console.log('User is authenticated, clearing from Supabase');
    const { error } = await supabase
      .from('active_fasting')
      .delete()
      .eq('user_id', userId);
      
    if (error) {
      console.error('Error clearing active fasting from Supabase:', error);
      throw error;
    }
  } catch (error) {
    console.error('Error in deleteActiveFasting:', error);
    // Make sure local storage is cleared even if Supabase fails
    localStorage.removeItem(STORAGE_KEYS.ACTIVE_FASTING);
    toast.error('Error clearing fasting data from the cloud. Local data has been cleared.');
  }
};

export const saveActiveFastingToSupabase = async (data: { startTime: string }, userId: string): Promise<void> => {
  try {
    if (import.meta.env.DEV) console.log('Saving active fasting to Supabase for user:', userId);
    const { error } = await supabase
      .from('active_fasting')
      .upsert({
        user_id: userId,
        start_time: data.startTime,
        updated_at: new Date().toISOString()
      }, {
        onConflict: 'user_id'
      });
      
    if (error) {
      console.error('Error saving active fasting to Supabase:', error);
      throw error;
    }
    
    if (import.meta.env.DEV) console.log('Successfully saved active fasting to Supabase');
  } catch (error) {
    console.error('Error in saveActiveFastingToSupabase:', error);
    // Always ensure local storage has the latest data
    localStorage.setItem(STORAGE_KEYS.ACTIVE_FASTING, JSON.stringify(data));
    toast.error('Error saving fasting data to the cloud. Working in offline mode.');
  }
};
